/**
 * @author        xinzhe.chai@zumper.com (Xinzhe Chai)
 * @copyright     Copyright (c) 2021, Zumper
 */

import { Button as ChakraButton, ButtonProps } from '@chakra-ui/react'
import React from 'react'

import * as styles from './styles'

/**
 * @param root0
 * @param root0.children
 * @param root0.style
 * @param root0.tabIndex
 * @param root0.isLoading
 * @param root0.spinner
 * @param root0.onClick
 * @deprecated Please use Button from @chakra-ui/react instead
 */
export const ClearButton = ({
  children,
  style,
  tabIndex = 0,
  isLoading,
  spinner,
  onClick,
  ...rest
}: ButtonProps) => {
  return (
    <ChakraButton
      {...rest}
      css={[styles.button, styles.clearButton, rest.css]}
      isLoading={isLoading}
      onClick={onClick}
      spinner={spinner}
      style={style}
      tabIndex={tabIndex}
      variant="ghost"
    >
      {children}
    </ChakraButton>
  )
}
